import { buildCardsFromDescriptionPrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateCardsFromDescription = async ({
  workflow,
  cardTypes,
  userDescription,
  stream = false,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const { messages } = buildCardsFromDescriptionPrompt({
    workflow,
    cardTypes,
    userDescription,
    stream
  })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'cards',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'cards',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
